/**
 * A deferred value that can be resolved at a later time outside of its closure.
 * @generic T - value of the deffered
 */
export type Deferred<T> = {
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
  value: Promise<T>;
};

/**
 * Create a new Deferred
 *
 * @generic T - value of the deffered
 * @returns Deferred<T>
 */
export const deferred = <T>(): Deferred<T> => {
  let resolve!: Deferred<T>['resolve'];
  let reject!: Deferred<T>['reject'];

  const value = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return {
    resolve,
    reject,
    value,
  };
};
